/*
 *
 * File JS per la Homepage
 *
 */

import './general.scss';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import animateIn from 'animations/animate-in/animate-in';

import cardIconText from 'components/cards/card-icon-text';
import iconTextList from 'components/icon-text-list/icon-text-list';
import textImgVar from 'imComponents/text-img-var/text-img-var';
import textOnBg from 'imComponents/text-on-bg/text-on-bg';
import cardsTextBg from 'components/cards-text-bg/cards-text-bg';
import boxImage from 'components/box-image/box-image';
import modal from 'imComponents/modal/modal';

import initHeader from 'components/header/header';
import heroSlider from 'imComponents/hero-slider/hero-slider';
import heroImage from 'imComponents/hero-image/hero-image';
import blockParallax from 'components/block-parallax/block-parallax';
import button from 'components/buttons/buttons';
// import cardText from "components/cards/card-text";
// import textSlider from "components/text-slider/text-slider";
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import cmsContent from 'components/cms-content/cms-content';
import footer from 'components/footer/footer';
import contactForm from 'components/contact-form/contact-form';

import accordion from 'imComponents/accordion/accordion';
import cardNews from 'components/cards/card-news';
import sliderNews from 'components/slider-news/slider-news';
import customQuote from 'components/custom-quote/custom-quote';
import titleBox from 'components/title-box/title-box';
import customAccordion from 'components/custom-accordion/custom-accordion';
import colTitleText from 'components/col-title-text/col-title-text';
import twoColList from 'components/two-col-list/two-col-list';
import textIframe from 'components/text-iframe/text-iframe';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';

//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector('body.wp-admin')) {
        initHeader();
        heroSlider();
    }
    accordion();
    modal();
    animateIn();
    iconTextList();
    sliderNews();
    carouselGallery();
}
if (document.querySelector('body.wp-admin')) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction('render_block_preview', initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
